import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'punctuationWrap'
})
export class PunctuationWrapPipe implements PipeTransform {
  possibleFrenchPunctuationsWithSpace = [";", "!", "?", ":",];
  excludedClasses = ["call-time"];
  constructor(
    private translateService: AgTranslateService,
    private sanitizer: DomSanitizer
  ){}
  transform(value: string, ..._args: unknown[]): string | SafeHtml {
    if (value){
      let transformedText = value;
      if (this.translateService.currentLang === "fr"){
        for (const punctuation of this.possibleFrenchPunctuationsWithSpace){
          if (transformedText.includes(punctuation) && !transformedText.includes(`&nbsp;${punctuation}`)){
            const replaceableText =" "+punctuation;
            const toBeReplacedWithText = "&nbsp;"+punctuation;
            const text1 = transformedText.replaceAll(replaceableText, punctuation);
            let text2 = text1.replaceAll(punctuation, toBeReplacedWithText);
            if (text2.includes("https&nbsp;:") || text2.includes("http&nbsp;:") || text2.includes("tel&nbsp;:") || text2.includes("mailto&nbsp;:") || text2.includes("&nbsp;?lng")){
              const text3 = text2.replaceAll("https&nbsp;:","https:");
              const text4 = text3.replaceAll("http&nbsp;:","http:");
              const text5 = text4.replaceAll("tel&nbsp;:","tel:");
              const text6 = text5.replaceAll("mailto&nbsp;:","mailto:");
              const text7= text6.replaceAll("&nbsp;?lng","?lng");
              text2 = text7;
            }
            transformedText = text2;
          }
        }
      }
      return this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(transformedText));
    } else {
      return value;
    }
  }

}
